<template>
    <ModalComponent name="editar-carpeta" title="Editar carpeta" @close="() => close(false)">
        <FormCarpeta
            :loading="loading"
            :carpeta="carpeta"
            @submit="submit"
        />
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormCarpeta from "@/components/backend/components/FormCarpeta";

    export default {
        props: {
            carpeta: {
                type: Object,
                require: true,
            },
        },
        data() {
            return {
                loading: false,
            };
        },
        methods: {
            close(actualizado) {
                this.$emit("close", "editar-carpeta", actualizado);
            },
            async submit(data) {
                this.loading = true;

                this.$emit("actualizar", {
                ...data,
                id: this.carpeta.id,
                });

                this.close(true);
                this.loading = false;
            },
        },
        components: {
            ModalComponent,
            FormCarpeta,
        },
    };
</script>
